<ion-content>
  <div data-cy="backdrop" class="modal-container" (click)="onDismiss()">
    <div class="modal-content" (click)="$event.preventDefault(); $event.stopPropagation()">
      <div class="date-time-picker">
        <div class="date-time-picker-header" [class.hidden]="!showDatePicker">
          <div class="date-time-picker-header-start">
            <div
              tappable
              class="date-time-picker-header-prev"
              [class.disabled]="showDatePicker && !canCheckPrevMonth"
              (click)="showDatePicker && onShowPrevMonth()"
            >
              <ion-icon class="date-time-picker-header-icon" src="/assets/custom-icons/vendors-page/chevron.svg"></ion-icon>
            </div>
          </div>
          <div class="date-time-picker-header-center"></div>

          <div class="date-time-picker-header-end">
            <div
              tappable
              data-cy="date-time-picker-header-next-button"
              class="date-time-picker-header-next"
              [class.disabled]="showDatePicker && !canCheckNextMonth"
              (click)="showDatePicker && onShowNextMonth()"
            >
              <ion-icon class="date-time-picker-header-icon" src="/assets/custom-icons/vendors-page/chevron.svg"></ion-icon>
            </div>
          </div>
        </div>

        <div class="date-time-picker-body" [style.height.px]="calendarContainerHeight">
          <div class="date-time-picker-content">
            <div class="date-time-picker-content-body">
              <swiper
                class="date-picker"
                #datePickerSwiper
                [dir]="swiperScrollingDirection"
                [class.hidden]="
                  !showDatePicker ||
                  isLoadingAvailableTimes ||
                  shouldShowLoadingErrorMessage ||
                  shouldShowItemNotAvailableBeforeDateMessage ||
                  shouldShowItemNotAvailableSoonMessage
                "
                [allowSlidePrev]="canCheckPrevMonth"
                [allowSlideNext]="canCheckNextMonth"
                [initialSlide]="selectedMonthIndex >= 0 ? selectedMonthIndex : 0"
                (swiper)="onDatePickerSwiperLoaded($event)"
                (activeIndexChange)="onDatePickerActiveIndexChange()"
              >
                <ng-template swiperSlide *ngFor="let calendar of datePicker">
                  <div class="date-picker-header">
                    <p class="date-picker-header-title" data-cy="calendar-header-title">{{ calendar.monthName }} {{ calendar.year }}</p>
                  </div>

                  <div class="date-picker-body">
                    <p *ngFor="let weekDayName of calendar.weekDayNames" class="date-picker-body-cell week-day-name">
                      {{ weekDayName }}
                    </p>

                    <div
                      *ngFor="let day of calendar.daysBeforeStartDay; let i = index"
                      data-cy="calendar-date-before-start-option"
                      class="date-picker-body-cell before-start"
                      [class.disabled]="day.isBeforeToday"
                      (click)="onUpdateSelectedDateFromDifferentMonth(day.valueIsoString)"
                    >
                      <p tappable class="date-picker-body-cell-content" [style.height.px]="calendarItemHeight">{{ day.value }}</p>
                    </div>

                    <div
                      *ngFor="let day of calendar.days; let i = index"
                      data-cy="calendar-date-option"
                      class="date-picker-body-cell"
                      [class.today]="day.isToday"
                      [class.disabled]="day.isBeforeToday"
                      [class.selected]="
                        selectedMonthIndex >= 0 &&
                        selectedDayIndex >= 0 &&
                        day.valueIsoString === datePicker[selectedMonthIndex].days[selectedDayIndex].valueIsoString
                      "
                      (click)="onUpdateSelectedDate(day.valueIsoString)"
                    >
                      <p tappable class="date-picker-body-cell-content" [style.height.px]="calendarItemHeight">{{ day.value }}</p>
                    </div>

                    <div
                      *ngFor="let day of calendar.daysAfterEndDay; let i = index"
                      data-cy="calendar-date-after-end-option"
                      class="date-picker-body-cell after-end"
                      [class.disabled]="day.isBeforeToday"
                      (click)="onUpdateSelectedDateFromDifferentMonth(day.valueIsoString)"
                    >
                      <p tappable class="date-picker-body-cell-content" [style.height.px]="calendarItemHeight">{{ day.value }}</p>
                    </div>
                  </div>
                </ng-template>
              </swiper>

              <div @animatedLoadingSpinner class="loading-spinner" *ngIf="isLoadingAvailableTimes">
                <ion-spinner duration="1000" name="dots"></ion-spinner>
              </div>

              <div
                @animatedErrorMessage
                class="picker-error"
                *ngIf="
                  shouldShowLoadingErrorMessage || shouldShowItemNotAvailableBeforeDateMessage || shouldShowItemNotAvailableSoonMessage
                "
              >
                <div class="picker-error-header">
                  <p class="picker-error-header-title">
                    {{ "ERROR_MESSAGE.DEFAULT_TITLE" | translate }}
                  </p>
                </div>

                <div class="picker-error-body">
                  <p
                    class="picker-error-body-message"
                    [innerHTML]="
                      shouldShowLoadingErrorMessage
                        ? ('ERROR_MESSAGE.DEFAULT_MESSAGE' | translate)
                        : ((shouldShowItemNotAvailableBeforeDateMessage
                            ? 'ITEM_AVAILABILITY_DATE_TIME_PICKER_MODAL.ITEM_NOT_AVAILABLE_BEFORE_DATE'
                            : 'ITEM_AVAILABILITY_DATE_TIME_PICKER_MODAL.ITEM_NOT_AVAILABLE_SOON'
                          )
                          | translate
                            : {
                                startDate:
                                  (datePicker[selectedMonthIndex].days[selectedDayIndex].valueIsoString
                                  | formatDateTime : { format: 'ddd DD MMMM', useRelativeDate: false }),
                                endDate:
                                  (nextAvailableTimes.dateIsoString | formatDateTime : { format: 'ddd DD MMMM', useRelativeDate: false })
                              })
                    "
                  ></p>
                </div>
              </div>

              <div
                @animatedTimePicker
                class="time-picker"
                *ngIf="
                  selectedMonthIndex >= 0 &&
                  selectedDayIndex >= 0 &&
                  nextAvailableTimes &&
                  nextAvailableTimes.dateIsoString === datePicker[selectedMonthIndex].days[selectedDayIndex].valueIsoString &&
                  !showDatePicker &&
                  !isLoadingAvailableTimes &&
                  !shouldShowLoadingErrorMessage &&
                  !shouldShowItemNotAvailableBeforeDateMessage &&
                  !shouldShowItemNotAvailableSoonMessage
                "
              >
                <div class="time-picker-header">
                  <p class="time-picker-header-title">
                    {{
                      nextAvailableTimes?.dateIsoString
                        ? (nextAvailableTimes.dateIsoString | formatDateTime : { format: "ddd DD MMMM YYYY", useRelativeDate: false })
                        : ""
                    }}
                  </p>
                </div>

                <div class="time-picker-body">
                  <div
                    data-cy="calendar-time-option"
                    class="time-picker-body-cell"
                    [class.disabled]="!hourMinuteValue.available"
                    [class.selected]="
                      newIsOrderForNowSelected
                        ? hourMinuteValue.isOrderForNow === true
                        : hourMinuteValue.dateTimeValue === newSelectedDateTime
                    "
                    *ngFor="let hourMinuteValue of nextAvailableTimes?.times"
                  >
                    <p
                      tappable
                      class="time-picker-body-cell-content"
                      [style.height.px]="calendarItemHeight"
                      (click)="onUpdateSelectedDateTime(hourMinuteValue)"
                    >
                      {{ hourMinuteValue.text }}
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div class="date-time-picker-content-footer">
              <ng-container
                *ngIf="
                  !shouldShowLoadingErrorMessage && !shouldShowItemNotAvailableBeforeDateMessage && !shouldShowItemNotAvailableSoonMessage
                "
              >
                <ion-button
                  *ngIf="showDatePicker"
                  color="green"
                  expand="block"
                  data-cy="calendar-submit-button"
                  class="select-button custom-button"
                  [class.disabled]="selectedDayIndex < 0"
                  (click)="onHandleSubmit()"
                >
                  <span *ngIf="selectedMonthIndex >= 0 && selectedDayIndex >= 0">
                    {{ "ITEM_AVAILABILITY_DATE_TIME_PICKER_MODAL.CHECK_AVAILABILITY_FOR" | translate }}

                    <span class="selected-date-time">
                      {{
                        datePicker[selectedMonthIndex].days[selectedDayIndex].valueIsoString
                          | formatDateTime : { format: "ddd DD MMM", useRelativeDate: false }
                      }}
                    </span>
                  </span>

                  <span *ngIf="selectedDayIndex < 0">
                    {{ "ITEM_AVAILABILITY_DATE_TIME_PICKER_MODAL.EMPTY_DATE" | translate }}
                  </span>
                </ion-button>

                <ion-button
                  *ngIf="!showDatePicker"
                  color="green"
                  expand="block"
                  data-cy="calendar-submit-button"
                  class="select-button custom-button"
                  [class.disabled]="!newSelectedDateTime && !newIsOrderForNowSelected"
                  (click)="onHandleSubmit()"
                >
                  <span *ngIf="newSelectedDateTime || newIsOrderForNowSelected">
                    {{ "ITEM_AVAILABILITY_DATE_TIME_PICKER_MODAL.SELECT" | translate }}

                    <span class="selected-date-time">
                      {{
                        newIsOrderForNowSelected
                          ? ("ORDER_FOR_NOW" | translate)
                          : (newSelectedDateTime
                            | formatDateTime
                              : {
                                  format: "ddd DD MMMM h:mm A",
                                  useRelativeDate: false
                                })
                      }}
                    </span>
                  </span>

                  <span *ngIf="!newSelectedDateTime && !newIsOrderForNowSelected">
                    {{ "ITEM_AVAILABILITY_DATE_TIME_PICKER_MODAL.EMPTY_TIME" | translate }}
                  </span>
                </ion-button>
              </ng-container>

              <ion-button
                *ngIf="shouldShowLoadingErrorMessage"
                color="danger"
                expand="block"
                class="error-button custom-button"
                (click)="onHandleLoadingError()"
              >
                {{ "TRY_AGAIN" | translate }}
              </ion-button>

              <ion-button
                *ngIf="shouldShowItemNotAvailableBeforeDateMessage"
                color="danger"
                expand="block"
                class="error-button custom-button"
                (click)="onHandleItemNotAvailableBeforeDateError()"
              >
                <span>
                  {{ "ITEM_AVAILABILITY_DATE_TIME_PICKER_MODAL.CHECK_AVAILABILITY_FOR" | translate }}
                  <span class="selected-date-time">
                    {{ nextAvailableTimes.dateIsoString | formatDateTime : { format: "ddd DD MMM", useRelativeDate: false } }}
                  </span>
                </span>
              </ion-button>

              <ion-button
                *ngIf="shouldShowItemNotAvailableSoonMessage"
                color="danger"
                expand="block"
                class="error-button custom-button"
                (click)="onHandleItemNotAvailableSoonError()"
              >
                {{ "ITEM_AVAILABILITY_DATE_TIME_PICKER_MODAL.TRY_A_LATER_DATE" | translate }}
              </ion-button>

              <ion-button
                color="grey"
                expand="block"
                data-cy="calendar-cancel-button"
                class="cancel-button custom-button"
                (click)="onGoBack()"
              >
                {{
                  (showDatePicker
                    ? "CANCEL"
                    : selectedDateTime || isOrderForNowSelected
                    ? "ITEM_AVAILABILITY_DATE_TIME_PICKER_MODAL.SELECT_A_DIFFERENT_DATE"
                    : "GO_BACK"
                  ) | translate
                }}
              </ion-button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</ion-content>
